import { AccountInfo } from './AccountInfo';
import { connect } from 'react-redux';
import { userDataSel } from 'src/store/modules/user';

const mapStateToProps = (state: any) => {
  return {
    userData: userDataSel(state)
  };
};

export const pureComponent = AccountInfo;
export default connect(mapStateToProps, null)(AccountInfo);
